// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{font-family:\"Nimbus\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;font-weight:400}.swiper-pagination.dish{bottom:20px!important;position:absolute!important;width:100%!important;z-index:10000000!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
